import axios from 'axios';

const apiUrl = process.env.REACT_APP_BACKEND_API_URL;

export interface DeliveryHistoryProductVariation {
  id: number;
  name: string;
  rarity: string;
  back_number: string;
  team_name: string;
  product_id: string;
}

export interface DeliveryHistory {
  order_number: string;
  recipient_name: string;
  postcode: string;
  address: string;
  create: string;
  deliveryproductvariation_set: {
    [productName: string]: DeliveryHistoryProductVariation[];
  };
}

export interface DeliveryHistoryPage {
  results: DeliveryHistory[];
  page: number;
  total_pages: number;
  total_count: number;
}

// マイページ 自分の発送依頼履歴を取得(発送ステータスは含まれない)
// 1ページ10件。範囲外のページ番号はバックエンド側で丸められる
export const getDeliveryHistory = async (page: number = 1): Promise<DeliveryHistoryPage> => {
  const response = await axios.get(`${apiUrl}/getDeliveryHistory/`, { params: { page: page }, withCredentials: true });
  return response.data;
}
